import FileUpload from '@/components/FormFields/FileUpload/FileUpload.tsx';
import SettingChipsField from '@/components/settings/SettingChipsField.tsx';
import { SettingsTextField } from '@/components/settings/SettingsTextField.tsx';
import SettingTextArea from '@/components/settings/SettingTextArea.tsx';
import { DashboardContext } from '@/contexts/DashboardContext.tsx';
import { SEOConfig } from '@superfunnel/types';
import { useContext, useEffect, useState } from 'react';
import { useDynamicPageSettingsContext } from './DynamicPageSettingsContext';
import { DynamicPageSettingsModalTabWrapper } from './DynamicPageSettingsModalTabWrapper';

export const SearchAndSocial = () => {
  const [edit, setEdit] = useState<boolean>(false);
  const { accountConfig } = useContext(DashboardContext);
  const { dynamicPage, updatePage } = useDynamicPageSettingsContext();
  const [seo, setSeo] = useState<Partial<SEOConfig>>({});

  useEffect(() => {
    if (!dynamicPage?.config) return;

    setSeo({
      ...accountConfig?.seo,
      ...dynamicPage?.config?.seo,
    });
  }, [dynamicPage, accountConfig]);

  const onSave = () => {
    if (!dynamicPage) return;
    setEdit(false);
    updatePage(
      { config: { seo: seo } },
      Object.keys(seo).map((key) => `config.seo.${key}`),
    );
  };

  const onDiscard = () => {
    setEdit(false);
    setSeo({
      ...accountConfig?.seo,
      ...dynamicPage?.config?.seo,
    });
  };

  useEffect(() => {
    if (!accountConfig || !dynamicPage) return;
    const accountConfigSeo = {
      ...accountConfig?.seo,
      ...dynamicPage?.config?.seo,
    };
    setEdit(JSON.stringify(accountConfigSeo) !== JSON.stringify(seo));
  }, [accountConfig, seo, dynamicPage]);

  return (
    <DynamicPageSettingsModalTabWrapper
      edit={edit}
      onDiscard={onDiscard}
      onSave={onSave}
    >
      <div className="col-span-2">
        <SeoForm seo={seo} onChange={setSeo} />
      </div>
    </DynamicPageSettingsModalTabWrapper>
  );
};

interface BaseProps {
  seo: SEOConfig;
  onChange: (seo: SEOConfig) => void;
}

const SeoForm = ({ seo, onChange }: BaseProps) => {
  return (
    <div className="flex flex-col gap-4">
      <SettingsTextField
        title="Title"
        value={seo.title || ''}
        setValue={(v: string) => onChange({ ...seo, title: v })}
      />
      <SettingTextArea
        className={'h-20'}
        title="Description"
        value={seo.description || ''}
        setValue={(v: string) => onChange({ ...seo, description: v })}
      />
      <SettingChipsField
        title="Keywords"
        selected={seo.keywords?.map((k) => ({ id: k, title: k })) || []}
        setSelected={(selected) =>
          onChange({ ...seo, keywords: selected.map((s) => s.title) })
        }
        options={[]}
      />
      <div className={'space-y-2'}>
        <h2 className="text-base-700 font-inter text-sm font-medium">Image</h2>
        <FileUpload
          image={seo.image}
          onSelected={(image) => onChange({ ...seo, image })}
        />
      </div>
      <div className={'space-y-2'}>
        <h2 className="text-base-700 font-inter text-sm font-medium">
          Favicon
        </h2>
        <FileUpload
          image={seo.favicon}
          onSelected={(favicon) => onChange({ ...seo, favicon })}
        />
      </div>
    </div>
  );
};
